////////////////////////////////////////////////////////////////////////////////////////
// Types
////////////////////////////////////////////////////////////////////////////////////////

const AssetType = {
  L1: "l1",
  Synth: "synth",
  Trade: "trade",
  Secured: "secured",
};

////////////////////////////////////////////////////////////////////////////////////////
// Exports
////////////////////////////////////////////////////////////////////////////////////////

export { AssetType };
